import { Component, OnInit } from '@angular/core';
import { IExternalLink } from 'helpers/interfaces/quick-link-interface';


@Component({
    selector: 'app-quick-links',
    templateUrl: './quick-links.component.html',
    styleUrls: ['./quick-links.component.scss'],
    standalone: false
})

export class QuickLinksComponent implements OnInit {

  externalLinks: IExternalLink[] = [];
  
  ngOnInit(): void {
    this._getExternalLinks();
  }

  private _getExternalLinks(): void {
    const quickLinksUrl = [
      {
        "text": "components.quicklinks.serviceNow",
        "url": "https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=5042010" 
      }];
      this.externalLinks = JSON.parse(JSON.stringify(quickLinksUrl));
  }
}
